import styled from 'styled-components';

export const DeveloperModalStyled = styled.div``;
